import React, { useCallback, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { VuiButton } from '../../../../../vodea/@vodea-ui/components/VuiButton';
import clsx from 'clsx';
import { Controller, useForm } from 'react-hook-form';
import VuiNumberFormat from '../../../../../vodea/@vodea-ui/components/VuiNumberFormat';
import NumberFormat from 'react-number-format';

interface Props {
  discount: number;
  onSave: (value: number) => void;
}

const ButtonAddDisc: React.FC<Props> = ({discount, onSave}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    errors,
    reset,
    handleSubmit,
    control
  } = useForm({
    defaultValues: {
      discount: 0
    }
  })

  const handleOnClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onSubmit = handleSubmit((data) => {
    onSave(data.discount);
    reset();
    handleOnClose();
  });

  const handleOpen = useCallback(() => {
    setIsOpen(true);
    reset({ discount });
  }, [discount]);

  return (
    <>
      <Modal show={isOpen} onHide={handleOnClose} backdrop={'static'} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add. Disc</Modal.Title>
        </Modal.Header>

        <form className={'form-wrapper'} onSubmit={onSubmit}>
          <Modal.Body>
            <div
              className={clsx({
                'form-group': true,
                error: errors.discount
              })}
            >
              <label className={'form-label'}>Discount</label>
              <Controller
                name={'discount'}
                control={control}
                render={props => (
                  <NumberFormat
                    className='form-control'
                    value={props.value}
                    allowNegative={false}
                    thousandSeparator={'.'}
                    decimalSeparator={','}
                    decimalScale={0}
                    placeholder={'IDR 0'}
                    prefix={'IDR '}
                    onValueChange={({ value }) => props.onChange(value)}
                  />
                )}
              />
              <label className={'label-help'}>{errors.discount?.message}</label>
            </div>

          </Modal.Body>

          <Modal.Footer>
            <Button variant={'light'} onClick={handleOnClose}>
              Cancel
            </Button>
            <VuiButton forSubmit={true} label={'Save'} loading={false} />
          </Modal.Footer>
        </form>
      </Modal>

      <div onClick={handleOpen} className='btn-chip'>
        Add. Disc{discount ? <VuiNumberFormat data={discount} value={discount} prefix=": IDR " /> : ''}
      </div>
    </>
  );
}

export default ButtonAddDisc;